import { ContextData } from 'src/app/data/context.data';

export class SheetURLData {

  private _data:any;

  constructor(data:any = null) {
    if (data) {
      this.data = data;
    }
  }

  /**
	 * data
	 */
  public set data(value: any) {
    this._data = value;
  }

  public get x():number {
    return +this._data.x;
  }

  public get y():number {
    return +this._data.y;
  }

  public get rotation():number {
    return +this._data.rotation;
  }

  public get size():number {
    return +this._data.fontSize;
  }

  public get width():number {
    return +this._data.width;
  }

  public get align(): string {
    return this._data.align;
  }

  /**
   * Cleanup
   */
  public cleanup():void {
    this._data = null;
  }

}
